import React from 'react';

export default function FullscreenIcon({
  width = 32,
  height = 32,
  className,
  style,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0_10068_12112)">
        <path
          d="M3.27187 0.0976355C5.78141 -0.187777 8.72882 0.261313 11.2844 0.0833137C12.6747 0.357474 12.6747 2.2459 11.2844 2.52006C8.8833 2.7308 6.06071 2.26227 3.70974 2.5262C3.02429 2.60293 2.60791 3.03463 2.523 3.71287L2.50458 11.3525C2.16902 12.6916 0.342876 12.6425 0.0789288 11.2881C0.24364 8.73674 -0.169672 5.85193 0.080975 3.3405C0.24364 1.72111 1.65545 0.281773 3.27187 0.0976355Z"
          fill="currentColor"
        />
        <path
          d="M20.6531 0.0949199C23.2209 0.240184 26.1387 -0.166964 28.6666 0.085713C30.3925 0.258598 31.8002 1.76648 31.9332 3.481C32.1266 5.9689 31.7828 8.70334 31.9312 11.2178C31.7429 12.6204 29.8472 12.7308 29.4984 11.3529L29.4799 3.71322C29.394 3.03498 28.9786 2.60328 28.2932 2.52656C25.9862 2.26672 23.2066 2.73729 20.8618 2.52962C19.3783 2.39868 19.2515 0.459103 20.6531 0.0949199Z"
          fill="currentColor"
        />
        <path
          d="M1.04944 19.6971C1.74511 19.5846 2.34564 19.9702 2.50626 20.6546L2.52468 28.2943C2.60141 28.9797 3.03313 29.396 3.71142 29.4809L11.4119 29.5147C12.7726 29.928 12.5649 31.8317 11.1429 31.934C8.64354 31.7663 5.87312 32.1489 3.40655 31.93C1.69191 31.7775 0.227929 30.3136 0.0754946 28.5991C-0.143438 26.1327 0.239183 23.3625 0.0714024 20.8633C0.0744716 20.3221 0.516429 19.784 1.05046 19.6981L1.04944 19.6971Z"
          fill="currentColor"
        />
        <path
          d="M30.4549 19.6974C31.2089 19.5747 31.8361 20.036 31.9302 20.789C31.7655 23.3116 32.1501 26.1095 31.9292 28.5984C31.7767 30.313 30.3127 31.7768 28.5981 31.9293C26.1315 32.1482 23.3611 31.7656 20.8618 31.9334C19.4387 31.8311 19.2321 29.9273 20.5927 29.514L28.2932 29.4802C29.0247 29.382 29.4176 28.9483 29.4831 28.2199C29.6969 25.8333 29.3112 23.1388 29.4871 20.7194C29.5526 20.2345 29.9751 19.7752 30.456 19.6974H30.4549Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10068_12112">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
